const messages = {
  availPoints: "Käytettävissä olevat pisteet",
  awaitingPoints: "Odottavat pisteet",
  board: {
    title: "Koontinäyttö",
    title2: "Kampanjan suorituskyky {year}",
    headline1: "Kampanjasi ja pisteesi yhdellä silmäyksellä",
    headline2: "Ansaitse pisteitä rengasostoistasi.",
    pointsBalanceToDate: "PISTESALDO TÄHÄN PÄIVÄÄN",
    availPoints: "Käytettävissä olevat pisteet",
    awaitingPoints: "Odottavat pisteet",
    yourRealisation: "TULOKSESI",
    yourEngagement: "Vuositavoitteesi: <b>{tyres} rengasta</b>",
    yourPoints: "PISTEESI",
    yourRetailPurchase: "OSTOSI YKSITYISKOHTAISESTI",
    yourRetailPurchaseCCS: "MYYNTISI YKSITYISKOHTAISESTI",
    pointsByPurchase: "ostoista kertyneet pisteet",
    pointsByBoosters: "booster-kampanjoista kertyneet pisteet",
    pointsByBSPurchase: "Bridgestone-ostoista kertyneet pisteet",
    pointsByBSPurchaseCCS: "Bridgestone-renkaiden myynnistä kertyneet pisteet",
    remaining: "Jäljellä olevat renkaat",
    yourGoal: "Edistyminen tavoitteeseen",
    unit: "renkaita",
    buttons: {
      learnMore: "Lue lisää pisteistäsi",
      learnMoreAboutMechanism: "Lue lisää mekanismista",
    },
    charts: {
      byBrand: "Tuotemerkin mukaan",
      bySize: "Vannekoon<br/>mukaan",
    },
    exploreResults: "Tutustu tuloksiisi",
    tyreLimitInfo:
      "Jokaiselle Booster-kampanjajaksolle vaaditaan vähintään 50 Bridgestone- ja/tai Firestone-renkaan sell-out-volyymi.",
  },
  charts: {
    byBrand: "Tuotemerkin mukaan",
    bySize: "vannekoon mukaan",
  },

  dashboard: {
    dashboardTitle: "Etusi",
    dashboardBox: {
      title: "Pistesaldo",
      description: "Nykyinen markkinointipisteidesi määrä",
      availPoints: "Käytettävissä olevat pisteet",
      awaitingPoints: "Odottavat pisteet",
      lastUpdate: "Viimeisin päivitys",
      button: "Lue lisää",
      points: "pisteet",
    },
  },
  soldTyres: "MYYDYT RENKAAT",
  receivedPoints: "ANSAITUT PISTEET",
  boosterCCS: {
    personalInfo: "Henkilötiedot",
    csNumberTitle: "Anna osallistuvien tilien numero(t)",
    tyresTitle: "Anna myytyjen renkaiden määrä",
    minTyresInfo:
      "Vähimmäismäärä on {tyres} Bridgestone/Firestone-rengasta. Palkkio koskee vain Bridgestone-renkaita.",
    tyresAmount: "Renkaiden määrä",
    filesTitle: "Lataa myyntitositteet",
    filesDescription:
      "Huom: huomioidaan vain myynnit, joissa renkaan vannekoko on mainittu.",
    addAnotherFile: "Lisää dokumentti",
    file: "Lataa dokumentti",
    formatInfo:
      "Tuetut tiedostomuodot: xlsx, jpeg ja pdf. Tiedoston enimmäiskoko: 8 MB",
    confrimationMessage:
      "<b>Kiitos osallistumisesta!</b> <br/>Pyyntösi on vastaanotettu ja välitetty Bridgestonen tiimille vahvistettavaksi.<br/>Saat sähköposti-ilmoituksen osallistumisesi tuloksista Booster CCS -kampanjassa.<br/>Nähdään pian Bridgestone Plus -palvelussa!",
  },
  sharePointModal: {
    header: "Jaa pisteitä",
    forShare: "Pisteet, jotka jaat",
    title: "Otsikko",
  },
  notFoundFile: "Tiedostoa ei ole valittu",
  chooseFile: "Valitse tiedosto",
};

export default {
  messages,
};
